// @ts-expect-error not typed yet

import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Small } from 'foundations-components/transitional/components/Small';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { AB_SELECT_VALUE } from 'EmailData/constants/details/abEmailConstants';
import { useEffect } from 'react';
import { isAutomatedAb } from 'EmailData/utils/details/abEmailUtil';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function isVersionWinner(emailDetails, version) {
  const automatedAb = isAutomatedAb(emailDetails);
  if (automatedAb) {
    return emailDetails.isEmailWinner(version);
  }
  return emailDetails.getWinningVariantType() === version;
}
function AbOptionTranslation({
  emailDetails,
  selectedVersion,
  setSelectedVersion
}) {
  const hasABWinner = emailDetails.hasWinner();
  const isInconclusive = emailDetails.isInconclusive();
  const isAWinner = hasABWinner && isVersionWinner(emailDetails, AB_SELECT_VALUE.A);
  const isBWinner = hasABWinner && isVersionWinner(emailDetails, AB_SELECT_VALUE.B);
  useEffect(() => {
    if (!selectedVersion) {
      if (!hasABWinner || isInconclusive) {
        setSelectedVersion(AB_SELECT_VALUE.A);
      } else {
        setSelectedVersion(isAWinner ? AB_SELECT_VALUE.A : AB_SELECT_VALUE.B);
      }
    }
  }, [emailDetails, hasABWinner, isAWinner, isInconclusive, selectedVersion, setSelectedVersion]);
  return /*#__PURE__*/_jsx(FormControl, {
    "data-test-id": "ab-translation-version-selection",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "email-management.modals.generateTranslatedVersion.abTranslate"
    }),
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(RadioInput, {
        checked: selectedVersion === AB_SELECT_VALUE.A,
        onChange: () => setSelectedVersion(AB_SELECT_VALUE.A),
        description: /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(Button, {
            "data-test-id": "view-email-version-a",
            use: "link",
            href: emailDetails.getLastTestPrimaryEmail().getPreviewUrl(),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "email-management.modals.generateTranslatedVersion.viewEmail"
            })
          })
        }),
        children: isAWinner ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.details.header.actions.titles.CLONE_AB_MASTER_WINNER"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.details.header.actions.titles.CLONE_AB_MASTER"
        })
      }), /*#__PURE__*/_jsx(RadioInput, {
        checked: selectedVersion === AB_SELECT_VALUE.B,
        onChange: () => setSelectedVersion(AB_SELECT_VALUE.B),
        description: /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(Button, {
            "data-test-id": "view-email-version-b",
            use: "link",
            href: emailDetails.getLastTestVariantEmail().getPreviewUrl(),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "email-management.modals.generateTranslatedVersion.viewEmail"
            })
          })
        }),
        children: isBWinner ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.details.header.actions.titles.CLONE_AB_VARIANT_WINNER"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.details.header.actions.titles.CLONE_AB_VARIANT"
        })
      })]
    })
  });
}
export default AbOptionTranslation;